var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIonicIosAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.443,
    height: 25.443,
    viewBox: "0 0 25.443 25.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-add",
    "data-name": "Icon ionic-ios-add",
    d: "M32.823,20.1H23.27V10.549a1.584,1.584,0,1,0-3.168,0V20.1H10.549a1.584,1.584,0,0,0,0,3.168H20.1v9.553a1.584,1.584,0,0,0,3.168,0V23.27h9.553a1.584,1.584,0,0,0,0-3.168Z",
    transform: "translate(-8.965 -8.965)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIonicIosAdd);
export default __webpack_public_path__ + "static/media/Icon-ionic-ios-add.a577fe432ffc71b5115b55c18b30fa06.svg";
export { ForwardRef as ReactComponent };